import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const slotRoute = {
    LIST_BY_COMPANY: "dashboard/core/slot/list",
    SAVE: "dashboard/core/slot/create",
    LIST_ALL_BY_COMPANY: "dashboard/core/slot/list-all-by-company",
    DELETE_SLOTH: "dashboard/core/slot/remove"
};

export default {
    save(slot) {
        return new Promise(resolve => {
            const method = slot.code ? 'put' : 'post';
            let code = -1;
            http[method](slotRoute.SAVE, slot)
                .then(({data}) => {
                    code = data.code;
                    if (code > 0) {
                        toast.ok("Se guardó el lote correctamente");
                        return;
                    }
                    if (code  == -1585) {
                        toast.info(""+data.message);
                        return;
                    }
                    if (code  == -1679) {
                        toast.info(""+data.message);
                        return;
                    }
                    toast.error("Error al guardar el lote" );
                })
                .catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(code));
        });
    },

    listByCompany(companyId) {
        return new Promise(resolve => {
            let newData = [];
            http.get(slotRoute.LIST_BY_COMPANY, {params: {companyId}})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron lotes para la empresa");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar los lotes");
                        return;
                    }
                    newData = data.info;
                }).catch(() => toast.error("Error al consultar los lotes"))
                .finally(() => resolve(newData));
        });
    },

    listAllByCompany(companyId) {
        return new Promise(resolve => {
            let newData = [];
            http.get(slotRoute.LIST_ALL_BY_COMPANY, {params: {companyId}})
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron todos lotes para la empresa");
                        return;
                    }
                    if (code <= 0) {
                        toast.error("Error al consultar todos los lotes");
                        return;
                    }
                    newData = data;
                }).catch(() => toast.error("Error al consultar todos los lotes"))
                .finally(() => resolve(newData));
        });
    },
    deleteSloth(slotId){
        return new Promise(resolve => {
            let code = -1;
            http.delete(slotRoute.DELETE_SLOTH,  {data:{slotId: slotId}})
                .then(({data}) => {
                    code = data.code;
                    if (code > 0) {
                        toast.ok(data.message);
                        return;
                    }
                    toast.error("Error al eliminar lote" );
                })
                .catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(code));
        });
    }
};